export default async function GetLandReferenceDocument(id) {
    let url = window.RealestateService+  `/api/Land/GetLandReferenceDocument?landId=${id}`
    let head = {
        "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}